import interceptors from "./interceptors/index";

const getUsers = () => {
  return interceptors({
    url: "/auth/users",
    method: "GET",
  });
};

const signUp = (data) => {
  return interceptors({
    url: "/auth/signup",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const deleteUser = (userame) => {
  return interceptors({
    url: "/auth/users/" + userame,
    method: "DELETE"
  })
}

const logoutUser = (data) => {
  return interceptors({
    url: "/auth/logout",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

const getUserStores = () => {
  const params = { formato: process.env.REACT_APP_BRAND}
  return interceptors({
    url: "/online-promocional/usuario-tienda",
    method: "GET",
    params: params
  })
}

const upsertUserStore = (data) => {
  return interceptors({
    url: "/online-promocional/usuario-tienda",
    method: "PUT",
    data: {
      idUsuario: data.get("idUsuario"),
      idTiendas: typeof data.getAll === 'function' ? data.getAll("idTiendas") : [data.get("idTiendas")],
      formato: data.get("formato"),
    }
  })
}

const deleteUserStore = (data) => {
  return interceptors({
    url: `/online-promocional/usuario-tienda/usuario/${data.get("idUsuario")}/formato/${data.get("formato")}`,
    method: "DELETE"
  })
}

const uploadCsvMasivo = (file, formato = process.env.REACT_APP_BRAND) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("formato", formato);
  
  return interceptors({
    url: "/online-promocional/usuario-tienda/csv",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export { getUsers, signUp, deleteUser, logoutUser, getUserStores, upsertUserStore, deleteUserStore, uploadCsvMasivo };
